export default __webpack_public_path__ + "ece83d2eaa2eb661332a781c9d899abd.png";